module.exports = __webpack_public_path__ + "static/img/home-screen-print-image.1504d1f.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/home-screen-print-image.jpg
// module id = ybuw
// module chunks = 1